module.exports = __webpack_public_path__ + "static/media/img_g2.1b71d731.webp";